// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/aqora_service.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import {PeripheralType, System} from "./system_pb.js";
import { Metric, MetricType } from "./metrics_pb.js";
import { Command } from "./command_pb.js";
import {GlobalPermission, Profile, SystemPermission, User} from "./user_pb.js";
import {Event, EventType, Severity} from "./event_pb.js";
import {Issue, IssueStatus, IssueType} from "./issue_pb.js";
import { DeviceTestResult } from "./device_test_result_pb.js";
import {Connectivity} from "./connectivity_pb.js";
import {TranslatableError} from "./system_mutation_pb.js";

/**
 * @generated from message wavin.aqora.v2.ListSystemsRequest
 */
export const ListSystemsRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ListSystemsRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListSystemsResponse
 */
export const ListSystemsResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ListSystemsResponse",
  () => [
    { no: 1, name: "systems", kind: "message", T: System, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.GetSystemRequest
 */
export const GetSystemRequest = proto3.makeMessageType(
  "wavin.aqora.v2.GetSystemRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListMetricsRequest
 */
export const ListMetricsRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ListMetricsRequest",
  () => [
    {no: 10, name: "targets", kind: "message", T: ListMetricsRequest_Target, repeated: true},
    { no: 3, name: "range_from", kind: "message", T: Timestamp },
    { no: 4, name: "range_to", kind: "message", T: Timestamp },
    { no: 5, name: "aggregation", kind: "enum", T: proto3.getEnumType(ListMetricsRequest_AggregationType) },
    { no: 6, name: "sort_order", kind: "enum", T: proto3.getEnumType(ListMetricsRequest_SortOrder) },
  ],
);

/**
 * @generated from enum wavin.aqora.v2.ListMetricsRequest.AggregationType
 */
export const ListMetricsRequest_AggregationType = proto3.makeEnum(
  "wavin.aqora.v2.ListMetricsRequest.AggregationType",
  [
    {no: 0, name: "AGGREGATION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "AGGREGATION_TYPE_MOST_RECENT_ONLY", localName: "MOST_RECENT_ONLY"},
    {no: 2, name: "AGGREGATION_TYPE_ACCUMULATE", localName: "ACCUMULATE"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.ListMetricsRequest.SortOrder
 */
export const ListMetricsRequest_SortOrder = proto3.makeEnum(
  "wavin.aqora.v2.ListMetricsRequest.SortOrder",
  [
    {no: 0, name: "SORT_ORDER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SORT_ORDER_ASC", localName: "ASC"},
    {no: 2, name: "SORT_ORDER_DESC", localName: "DESC"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListMetricsRequest.Target
 */
export const ListMetricsRequest_Target = proto3.makeMessageType(
  "wavin.aqora.v2.ListMetricsRequest.Target",
  () => [
    {no: 1, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "types", kind: "enum", T: proto3.getEnumType(MetricType), repeated: true},
  ],
  {localName: "ListMetricsRequest_Target"},
);

/**
 * @generated from message wavin.aqora.v2.ListMetricsResponse
 */
export const ListMetricsResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ListMetricsResponse",
  () => [
    { no: 1, name: "metrics", kind: "message", T: Metric, repeated: true },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ExecuteCommandRequest
 */
export const ExecuteCommandRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ExecuteCommandRequest",
  () => [
    { no: 1, name: "command", kind: "message", T: Command },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ExecuteCommandResponse
 */
export const ExecuteCommandResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ExecuteCommandResponse",
  () => [
    { no: 1, name: "response", kind: "message", T: Struct },
    {no: 2, name: "command_state", kind: "enum", T: proto3.getEnumType(ExecuteCommandResponse_CommandState)},
    {no: 3, name: "execution_time", kind: "message", T: Timestamp},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.ExecuteCommandResponse.CommandState
 */
export const ExecuteCommandResponse_CommandState = proto3.makeEnum(
  "wavin.aqora.v2.ExecuteCommandResponse.CommandState",
  [
    {no: 0, name: "COMMAND_STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMMAND_STATE_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "COMMAND_STATE_FAILURE", localName: "FAILURE"},
    {no: 3, name: "COMMAND_STATE_DEVICE_TIMEOUT", localName: "DEVICE_TIMEOUT"},
    {no: 4, name: "COMMAND_STATE_IGNORED", localName: "IGNORED"},
    {no: 5, name: "COMMAND_STATE_FAILURE_OTA_IN_PROGRESS", localName: "FAILURE_OTA_IN_PROGRESS"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.GetUserRequest
 */
export const GetUserRequest = proto3.makeMessageType(
  "wavin.aqora.v2.GetUserRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpdateUserProfileRequest
 */
export const UpdateUserProfileRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateUserProfileRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "profile", kind: "message", T: Profile },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListUsersRequest
 */
export const ListUsersRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ListUsersRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListUsersResponse
 */
export const ListUsersResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ListUsersResponse",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListUsersForSystemRequest
 */
export const ListUsersForSystemRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ListUsersForSystemRequest",
  () => [
    {no: 1, name: "system_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListUsersForSystemResponse
 */
export const ListUsersForSystemResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ListUsersForSystemResponse",
  () => [
    {no: 1, name: "users", kind: "message", T: ListUsersForSystemResponse_Users, repeated: true},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListUsersForSystemResponse.Users
 */
export const ListUsersForSystemResponse_Users = proto3.makeMessageType(
  "wavin.aqora.v2.ListUsersForSystemResponse.Users",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 4, name: "permission", kind: "message", T: SystemPermission},
  ],
  {localName: "ListUsersForSystemResponse_Users"},
);

/**
 * @generated from message wavin.aqora.v2.UpsertUserSystemRolesRequest
 */
export const UpsertUserSystemRolesRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpsertUserSystemRolesRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {no: 2, name: "system_permissions", kind: "message", T: SystemPermission, repeated: true},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListEventsRequest
 */
export const ListEventsRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ListEventsRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "severities", kind: "enum", T: proto3.getEnumType(Severity), repeated: true },
    {no: 5, name: "filter_types", kind: "enum", T: proto3.getEnumType(EventType), repeated: true},
    {no: 6, name: "no_children", kind: "scalar", T: 8 /* ScalarType.BOOL */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListEventsResponse
 */
export const ListEventsResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ListEventsResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListIssuesRequest
 */
export const ListIssuesRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ListIssuesRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "range_from", kind: "message", T: Timestamp },
    { no: 4, name: "range_to", kind: "message", T: Timestamp },
    { no: 5, name: "order_by", kind: "message", T: OrderBy, repeated: true },
    { no: 6, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(IssueStatus) },
    {no: 8, name: "severities", kind: "enum", T: proto3.getEnumType(Severity), repeated: true},
    {no: 9, name: "issue_types", kind: "enum", T: proto3.getEnumType(IssueType), repeated: true},
  ],
);

/**
 * specifies the sort order of a specific field.
 *
 * @generated from message wavin.aqora.v2.OrderBy
 */
export const OrderBy = proto3.makeMessageType(
  "wavin.aqora.v2.OrderBy",
  () => [
    { no: 1, name: "field", kind: "enum", T: proto3.getEnumType(OrderBy_AvailableFields) },
    { no: 2, name: "sort_order", kind: "enum", T: proto3.getEnumType(OrderBy_SortOrder) },
  ],
);

/**
 * available fields for which field gets validated against
 *
 * @generated from enum wavin.aqora.v2.OrderBy.AvailableFields
 */
export const OrderBy_AvailableFields = proto3.makeEnum(
  "wavin.aqora.v2.OrderBy.AvailableFields",
  [
    {no: 0, name: "AVAILABLE_FIELDS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "AVAILABLE_FIELDS_FIRST_OCCURRENCE", localName: "FIRST_OCCURRENCE"},
    {no: 2, name: "AVAILABLE_FIELDS_LAST_OCCURRENCE", localName: "LAST_OCCURRENCE"},
    {no: 3, name: "AVAILABLE_FIELDS_SEVERITY", localName: "SEVERITY"},
  ],
);

/**
 * sort order
 *
 * @generated from enum wavin.aqora.v2.OrderBy.SortOrder
 */
export const OrderBy_SortOrder = proto3.makeEnum(
  "wavin.aqora.v2.OrderBy.SortOrder",
  [
    {no: 0, name: "SORT_ORDER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SORT_ORDER_ASC", localName: "ASC"},
    {no: 2, name: "SORT_ORDER_DESC", localName: "DESC"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListIssuesResponse
 */
export const ListIssuesResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ListIssuesResponse",
  () => [
    { no: 1, name: "issues", kind: "message", T: Issue, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {no: 3, name: "total_issues", kind: "scalar", T: 5 /* ScalarType.INT32 */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.MarkIssueAsResolvedRequest
 */
export const MarkIssueAsResolvedRequest = proto3.makeMessageType(
  "wavin.aqora.v2.MarkIssueAsResolvedRequest",
  () => [
    {no: 1, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "issue_type", kind: "enum", T: proto3.getEnumType(IssueType)},
    {no: 3, name: "first_occurrence_time", kind: "message", T: Timestamp},
  ],
);

/**
 * @generated from message wavin.aqora.v2.MarkIssueAsResolvedResponse
 */
export const MarkIssueAsResolvedResponse = proto3.makeMessageType(
  "wavin.aqora.v2.MarkIssueAsResolvedResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.ListSystemsIssuesRequest
 */
export const ListSystemsIssuesRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ListSystemsIssuesRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListSystemsIssuesResponse
 */
export const ListSystemsIssuesResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ListSystemsIssuesResponse",
  () => [
    { no: 1, name: "system_issues", kind: "message", T: ListSystemsIssuesResponse_SystemIssues, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListSystemsIssuesResponse.SystemIssues
 */
export const ListSystemsIssuesResponse_SystemIssues = proto3.makeMessageType(
  "wavin.aqora.v2.ListSystemsIssuesResponse.SystemIssues",
  () => [
    { no: 1, name: "system_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_issue_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
  {localName: "ListSystemsIssuesResponse_SystemIssues"},
);

/**
 * @generated from message wavin.aqora.v2.LinkDeviceRequest
 */
export const LinkDeviceRequest = proto3.makeMessageType(
  "wavin.aqora.v2.LinkDeviceRequest",
  () => [
    { no: 1, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.LinkDeviceResponse
 */
export const LinkDeviceResponse = proto3.makeMessageType(
  "wavin.aqora.v2.LinkDeviceResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.LinkDevicePeripheralsRequest
 */
export const LinkDevicePeripheralsRequest = proto3.makeMessageType(
  "wavin.aqora.v2.LinkDevicePeripheralsRequest",
  () => [
    {
      no: 1,
      name: "peripheral_serials",
      kind: "message",
      T: LinkDevicePeripheralsRequest_PeripheralProduct,
      repeated: true
    },
  ],
);

/**
 * @todo one request for all product peripherals or multiple?
 *
 * @generated from message wavin.aqora.v2.LinkDevicePeripheralsRequest.PeripheralProduct
 */
export const LinkDevicePeripheralsRequest_PeripheralProduct = proto3.makeMessageType(
  "wavin.aqora.v2.LinkDevicePeripheralsRequest.PeripheralProduct",
  () => [
    {no: 1, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "peripheral_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
  {localName: "LinkDevicePeripheralsRequest_PeripheralProduct"},
);

/**
 * @generated from message wavin.aqora.v2.LinkDevicePeripheralsResponse
 */
export const LinkDevicePeripheralsResponse = proto3.makeMessageType(
  "wavin.aqora.v2.LinkDevicePeripheralsResponse",
  () => [
    {no: 1, name: "done", kind: "scalar", T: 8 /* ScalarType.BOOL */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.LinkDevicePeripheralOptionsRequest
 */
export const LinkDevicePeripheralOptionsRequest = proto3.makeMessageType(
  "wavin.aqora.v2.LinkDevicePeripheralOptionsRequest",
  () => [
    {no: 1, name: "system_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.LinkDevicePeripheralOptionsResponse
 */
export const LinkDevicePeripheralOptionsResponse = proto3.makeMessageType(
  "wavin.aqora.v2.LinkDevicePeripheralOptionsResponse",
  () => [
    {no: 1, name: "system_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {
      no: 2,
      name: "product_options",
      kind: "message",
      T: LinkDevicePeripheralOptionsResponse_ProductOptions,
      repeated: true
    },
  ],
);

/**
 * @generated from message wavin.aqora.v2.LinkDevicePeripheralOptionsResponse.ProductOptions
 */
export const LinkDevicePeripheralOptionsResponse_ProductOptions = proto3.makeMessageType(
  "wavin.aqora.v2.LinkDevicePeripheralOptionsResponse.ProductOptions",
  () => [
    {no: 1, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "type", kind: "enum", T: proto3.getEnumType(PeripheralType)},
    {no: 3, name: "peripheral_options", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true},
  ],
  {localName: "LinkDevicePeripheralOptionsResponse_ProductOptions"},
);

/**
 * @generated from message wavin.aqora.v2.UpsertDeviceTestResultRequest
 */
export const UpsertDeviceTestResultRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpsertDeviceTestResultRequest",
  () => [
    { no: 1, name: "result", kind: "message", T: DeviceTestResult },
  ],
);

/**
 * @generated from message wavin.aqora.v2.UpsertCommissioningTestResponse
 */
export const UpsertCommissioningTestResponse = proto3.makeMessageType(
  "wavin.aqora.v2.UpsertCommissioningTestResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.ResetDeviceCommissioningStateRequest
 */
export const ResetDeviceCommissioningStateRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ResetDeviceCommissioningStateRequest",
  () => [
    { no: 1, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message wavin.aqora.v2.ResetDeviceCommissioningStateResponse
 */
export const ResetDeviceCommissioningStateResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ResetDeviceCommissioningStateResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.GetDeviceDetailsRequest
 */
export const GetDeviceDetailsRequest = proto3.makeMessageType(
  "wavin.aqora.v2.GetDeviceDetailsRequest",
  () => [
    {no: 1, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.DeviceDetailsResponse
 */
export const DeviceDetailsResponse = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceDetailsResponse",
  () => [
    {no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "external_link", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 3, name: "external_link_text", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 5, name: "external_link_label", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 6, name: "firmware_version", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 4, name: "connectivity", kind: "message", T: Connectivity},
    {no: 7, name: "eol_tests", kind: "message", T: DeviceDetailsResponse_EOLTest, repeated: true},
    {no: 8, name: "water_height_sensor_offset", kind: "scalar", T: 2 /* ScalarType.FLOAT */, repeated: true},
    {
      no: 10,
      name: "available_device_specific_command",
      kind: "message",
      T: DeviceDetailsResponse_DeviceSpecificCommandSpec,
      repeated: true
    },
  ],
);

/**
 * @generated from message wavin.aqora.v2.DeviceDetailsResponse.EOLTest
 */
export const DeviceDetailsResponse_EOLTest = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceDetailsResponse.EOLTest",
  () => [
    {no: 1, name: "lines", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true},
    {no: 3, name: "created_at", kind: "message", T: Timestamp},
  ],
  {localName: "DeviceDetailsResponse_EOLTest"},
);

/**
 * @generated from message wavin.aqora.v2.DeviceDetailsResponse.DeviceSpecificCommandSpec
 */
export const DeviceDetailsResponse_DeviceSpecificCommandSpec = proto3.makeMessageType(
  "wavin.aqora.v2.DeviceDetailsResponse.DeviceSpecificCommandSpec",
  () => [
    {no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "translation_key", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 3, name: "accepts_payload", kind: "scalar", T: 8 /* ScalarType.BOOL */},
    {no: 4, name: "payload_is_numeric", kind: "scalar", T: 8 /* ScalarType.BOOL */},
  ],
  {localName: "DeviceDetailsResponse_DeviceSpecificCommandSpec"},
);

/**
 * @generated from message wavin.aqora.v2.LinkUserToSystemByEmailRequest
 */
export const LinkUserToSystemByEmailRequest = proto3.makeMessageType(
  "wavin.aqora.v2.LinkUserToSystemByEmailRequest",
  () => [
    {no: 1, name: "user_email", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "system_permissions", kind: "message", T: SystemPermission},
  ],
);

/**
 * @generated from message wavin.aqora.v2.LinkUserToSystemByEmailResponse
 */
export const LinkUserToSystemByEmailResponse = proto3.makeMessageType(
  "wavin.aqora.v2.LinkUserToSystemByEmailResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.LinkUserToSystemsByEmailRequest
 */
export const LinkUserToSystemsByEmailRequest = proto3.makeMessageType(
  "wavin.aqora.v2.LinkUserToSystemsByEmailRequest",
  () => [
    {no: 1, name: "user_email", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "system_permissions", kind: "message", T: SystemPermission, repeated: true},
    {no: 3, name: "global_permissions", kind: "enum", T: proto3.getEnumType(GlobalPermission), repeated: true},
  ],
);

/**
 * @generated from message wavin.aqora.v2.LinkUserToSystemsByEmailResponse
 */
export const LinkUserToSystemsByEmailResponse = proto3.makeMessageType(
  "wavin.aqora.v2.LinkUserToSystemsByEmailResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.CreateNoteRequest
 */
export const CreateNoteRequest = proto3.makeMessageType(
  "wavin.aqora.v2.CreateNoteRequest",
  () => [
    {no: 1, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "event_type", kind: "enum", T: proto3.getEnumType(EventType)},
    {no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.CreateNoteResponse
 */
export const CreateNoteResponse = proto3.makeMessageType(
  "wavin.aqora.v2.CreateNoteResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.DeleteNoteRequest
 */
export const DeleteNoteRequest = proto3.makeMessageType(
  "wavin.aqora.v2.DeleteNoteRequest",
  () => [
    {no: 1, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "event_type", kind: "enum", T: proto3.getEnumType(EventType)},
    {no: 3, name: "time", kind: "message", T: Timestamp},
  ],
);

/**
 * @generated from message wavin.aqora.v2.DeleteNoteResponse
 */
export const DeleteNoteResponse = proto3.makeMessageType(
  "wavin.aqora.v2.DeleteNoteResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.UserSetupPasswordWithTokenRequest
 */
export const UserSetupPasswordWithTokenRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UserSetupPasswordWithTokenRequest",
  () => [
    {no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.UserSetupPasswordWithTokenResponse
 */
export const UserSetupPasswordWithTokenResponse = proto3.makeMessageType(
  "wavin.aqora.v2.UserSetupPasswordWithTokenResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.MarkDeviceConfigurationRequest
 */
export const MarkDeviceConfigurationRequest = proto3.makeMessageType(
  "wavin.aqora.v2.MarkDeviceConfigurationRequest",
  () => [
    {no: 1, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "needs_config", kind: "scalar", T: 8 /* ScalarType.BOOL */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.MarkDeviceConfigurationResponse
 */
export const MarkDeviceConfigurationResponse = proto3.makeMessageType(
  "wavin.aqora.v2.MarkDeviceConfigurationResponse",
  [],
);

/**
 * @generated from message wavin.aqora.v2.GetBillOfMaterialsRequest
 */
export const GetBillOfMaterialsRequest = proto3.makeMessageType(
  "wavin.aqora.v2.GetBillOfMaterialsRequest",
  () => [
    {no: 1, name: "system_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "cutting_loss", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
    {no: 3, name: "screw_inserts", kind: "scalar", T: 8 /* ScalarType.BOOL */},
    {no: 4, name: "connector_tool_aquacell_160", kind: "scalar", T: 8 /* ScalarType.BOOL */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.GetBillOfMaterialsResponse
 */
export const GetBillOfMaterialsResponse = proto3.makeMessageType(
  "wavin.aqora.v2.GetBillOfMaterialsResponse",
  () => [
    {no: 10, name: "system_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 11, name: "system_title", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 1, name: "items", kind: "message", T: GetBillOfMaterialsResponse_ReservoirItems, repeated: true},
    {no: 2, name: "total_gross_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
    {no: 3, name: "total_m2_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
);

/**
 * @generated from message wavin.aqora.v2.GetBillOfMaterialsResponse.Alert
 */
export const GetBillOfMaterialsResponse_Alert = proto3.makeMessageType(
  "wavin.aqora.v2.GetBillOfMaterialsResponse.Alert",
  () => [
    {no: 2, name: "alert_type", kind: "enum", T: proto3.getEnumType(GetBillOfMaterialsResponse_Alert_AlertType)},
    {no: 3, name: "error", kind: "message", T: TranslatableError},
  ],
  {localName: "GetBillOfMaterialsResponse_Alert"},
);

/**
 * @generated from enum wavin.aqora.v2.GetBillOfMaterialsResponse.Alert.AlertType
 */
export const GetBillOfMaterialsResponse_Alert_AlertType = proto3.makeEnum(
  "wavin.aqora.v2.GetBillOfMaterialsResponse.Alert.AlertType",
  [
    {no: 0, name: "ALERT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ALERT_TYPE_INVALID_DRAIN_CONFIG", localName: "INVALID_DRAIN_CONFIG"},
    {no: 2, name: "ALERT_TYPE_TOO_LOW_AMOUNT_OF_DRAINS", localName: "TOO_LOW_AMOUNT_OF_DRAINS"},
    {no: 3, name: "ALERT_TYPE_CRATE_TYPE_NOT_SET", localName: "CRATE_TYPE_NOT_SET"},
    {no: 4, name: "ALERT_TYPE_POLDERVALVE_COUNT_LOW", localName: "POLDERVALVE_COUNT_LOW"},
    {no: 5, name: "ALERT_TYPE_POLDERVALVE_INVALID_DRAIN_TYPE", localName: "POLDERVALVE_INVALID_DRAIN_TYPE"},
    {no: 6, name: "ALERT_TYPE_NO_DIRECT_DRAIN", localName: "NO_DIRECT_DRAIN"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.GetBillOfMaterialsResponse.Item
 */
export const GetBillOfMaterialsResponse_Item = proto3.makeMessageType(
  "wavin.aqora.v2.GetBillOfMaterialsResponse.Item",
  () => [
    {no: 1, name: "sap_code", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 5, name: "gross_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
    {no: 6, name: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 7, name: "sap_info", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
  {localName: "GetBillOfMaterialsResponse_Item"},
);

/**
 * @generated from message wavin.aqora.v2.GetBillOfMaterialsResponse.ReservoirItems
 */
export const GetBillOfMaterialsResponse_ReservoirItems = proto3.makeMessageType(
  "wavin.aqora.v2.GetBillOfMaterialsResponse.ReservoirItems",
  () => [
    {no: 1, name: "reservoir_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 5, name: "reservoir_title", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "items", kind: "message", T: GetBillOfMaterialsResponse_Item, repeated: true},
    {no: 3, name: "subtotal_gross_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
    {no: 4, name: "alerts", kind: "message", T: GetBillOfMaterialsResponse_Alert, repeated: true},
    {no: 6, name: "m2_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
    {no: 7, name: "area", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
  {localName: "GetBillOfMaterialsResponse_ReservoirItems"},
);

/**
 * @generated from message wavin.aqora.v2.GetGeneralStatisticsRequest
 */
export const GetGeneralStatisticsRequest = proto3.makeMessageType(
  "wavin.aqora.v2.GetGeneralStatisticsRequest",
  [],
);

/**
 * @generated from message wavin.aqora.v2.GetGeneralStatisticsResponse
 */
export const GetGeneralStatisticsResponse = proto3.makeMessageType(
  "wavin.aqora.v2.GetGeneralStatisticsResponse",
  () => [
    {no: 1, name: "connected_area", kind: "message", T: GetGeneralStatisticsResponse_ConnectedArea, opt: true},
    {no: 2, name: "systems_summary", kind: "message", T: GetGeneralStatisticsResponse_SystemsSummary, opt: true},
    {no: 3, name: "devices_summary", kind: "message", T: GetGeneralStatisticsResponse_DevicesSummary, opt: true},
    {no: 4, name: "kpi_stats", kind: "message", T: GetGeneralStatisticsResponse_KPIStats, opt: true},
    {no: 5, name: "issues_summary", kind: "message", T: GetGeneralStatisticsResponse_IssuesSummary, opt: true},
  ],
);

/**
 * @generated from message wavin.aqora.v2.GetGeneralStatisticsResponse.ConnectedArea
 */
export const GetGeneralStatisticsResponse_ConnectedArea = proto3.makeMessageType(
  "wavin.aqora.v2.GetGeneralStatisticsResponse.ConnectedArea",
  () => [
    {no: 1, name: "green_blue", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
  {localName: "GetGeneralStatisticsResponse_ConnectedArea"},
);

/**
 * @generated from message wavin.aqora.v2.GetGeneralStatisticsResponse.SystemsSummary
 */
export const GetGeneralStatisticsResponse_SystemsSummary = proto3.makeMessageType(
  "wavin.aqora.v2.GetGeneralStatisticsResponse.SystemsSummary",
  () => [
    {no: 1, name: "total_systems", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 2, name: "production", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 12, name: "production_legacy", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 3, name: "config", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 4, name: "ready_to_install", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 5, name: "advice", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 6, name: "mocks", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 10, name: "other", kind: "scalar", T: 5 /* ScalarType.INT32 */},
  ],
  {localName: "GetGeneralStatisticsResponse_SystemsSummary"},
);

/**
 * @generated from message wavin.aqora.v2.GetGeneralStatisticsResponse.DevicesSummary
 */
export const GetGeneralStatisticsResponse_DevicesSummary = proto3.makeMessageType(
  "wavin.aqora.v2.GetGeneralStatisticsResponse.DevicesSummary",
  () => [
    {no: 1, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 2, name: "poldervalve_produced", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 3, name: "linked_poldervalve", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 4, name: "linked_mpc_legacy", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 5, name: "linked_mock", kind: "scalar", T: 5 /* ScalarType.INT32 */},
    {no: 6, name: "linked_other", kind: "scalar", T: 5 /* ScalarType.INT32 */},
  ],
  {localName: "GetGeneralStatisticsResponse_DevicesSummary"},
);

/**
 * @generated from message wavin.aqora.v2.GetGeneralStatisticsResponse.KPIStats
 */
export const GetGeneralStatisticsResponse_KPIStats = proto3.makeMessageType(
  "wavin.aqora.v2.GetGeneralStatisticsResponse.KPIStats",
  () => [
    {no: 1, name: "rainwater_captured_l", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
  {localName: "GetGeneralStatisticsResponse_KPIStats"},
);

/**
 * @generated from message wavin.aqora.v2.GetGeneralStatisticsResponse.IssuesSummary
 */
export const GetGeneralStatisticsResponse_IssuesSummary = proto3.makeMessageType(
  "wavin.aqora.v2.GetGeneralStatisticsResponse.IssuesSummary",
  () => [
    {
      no: 1,
      name: "count_per_type_open",
      kind: "map",
      K: 9 /* ScalarType.STRING */,
      V: {kind: "scalar", T: 5 /* ScalarType.INT32 */}
    },
  ],
  {localName: "GetGeneralStatisticsResponse_IssuesSummary"},
);

/**
 * @generated from message wavin.aqora.v2.ListActionsAndIssuesGraphRequest
 */
export const ListActionsAndIssuesGraphRequest = proto3.makeMessageType(
  "wavin.aqora.v2.ListActionsAndIssuesGraphRequest",
  () => [
    {no: 1, name: "targets", kind: "message", T: ListActionsAndIssuesGraphRequest_Target, repeated: true},
    {no: 3, name: "range_from", kind: "message", T: Timestamp},
    {no: 4, name: "range_to", kind: "message", T: Timestamp},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListActionsAndIssuesGraphRequest.Target
 */
export const ListActionsAndIssuesGraphRequest_Target = proto3.makeMessageType(
  "wavin.aqora.v2.ListActionsAndIssuesGraphRequest.Target",
  () => [
    {no: 1, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "types", kind: "enum", T: proto3.getEnumType(MetricType), repeated: true},
  ],
  {localName: "ListActionsAndIssuesGraphRequest_Target"},
);

/**
 * @generated from message wavin.aqora.v2.ListActionsAndIssuesGraphResponse
 */
export const ListActionsAndIssuesGraphResponse = proto3.makeMessageType(
  "wavin.aqora.v2.ListActionsAndIssuesGraphResponse",
  () => [
    {no: 1, name: "issue_lanes", kind: "message", T: ListActionsAndIssuesGraphResponse_IssueLane, repeated: true},
    {no: 2, name: "action_lanes", kind: "message", T: ListActionsAndIssuesGraphResponse_ActionLane, repeated: true},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListActionsAndIssuesGraphResponse.Issue
 */
export const ListActionsAndIssuesGraphResponse_Issue = proto3.makeMessageType(
  "wavin.aqora.v2.ListActionsAndIssuesGraphResponse.Issue",
  () => [
    {no: 1, name: "issue_type", kind: "enum", T: proto3.getEnumType(IssueType)},
    {no: 2, name: "resource_title", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 3, name: "first_occurrence_time", kind: "message", T: Timestamp},
    {no: 4, name: "closed_at_time", kind: "message", T: Timestamp},
  ],
  {localName: "ListActionsAndIssuesGraphResponse_Issue"},
);

/**
 * @generated from message wavin.aqora.v2.ListActionsAndIssuesGraphResponse.Action
 */
export const ListActionsAndIssuesGraphResponse_Action = proto3.makeMessageType(
  "wavin.aqora.v2.ListActionsAndIssuesGraphResponse.Action",
  () => [
    {no: 1, name: "type", kind: "enum", T: proto3.getEnumType(ListActionsAndIssuesGraphResponse_Action_Type)},
    {no: 2, name: "from_title", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 3, name: "to_title", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 4, name: "volume_l", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
    {no: 5, name: "start_time", kind: "message", T: Timestamp},
    {no: 6, name: "stop_time", kind: "message", T: Timestamp},
  ],
  {localName: "ListActionsAndIssuesGraphResponse_Action"},
);

/**
 * @generated from enum wavin.aqora.v2.ListActionsAndIssuesGraphResponse.Action.Type
 */
export const ListActionsAndIssuesGraphResponse_Action_Type = proto3.makeEnum(
  "wavin.aqora.v2.ListActionsAndIssuesGraphResponse.Action.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_SUPPLY_TO", localName: "SUPPLY_TO"},
    {no: 2, name: "TYPE_DUMP_FROM", localName: "DUMP_FROM"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.ListActionsAndIssuesGraphResponse.IssueLane
 */
export const ListActionsAndIssuesGraphResponse_IssueLane = proto3.makeMessageType(
  "wavin.aqora.v2.ListActionsAndIssuesGraphResponse.IssueLane",
  () => [
    {no: 1, name: "issues", kind: "message", T: ListActionsAndIssuesGraphResponse_Issue, repeated: true},
  ],
  {localName: "ListActionsAndIssuesGraphResponse_IssueLane"},
);

/**
 * @generated from message wavin.aqora.v2.ListActionsAndIssuesGraphResponse.ActionLane
 */
export const ListActionsAndIssuesGraphResponse_ActionLane = proto3.makeMessageType(
  "wavin.aqora.v2.ListActionsAndIssuesGraphResponse.ActionLane",
  () => [
    {no: 1, name: "actions", kind: "message", T: ListActionsAndIssuesGraphResponse_Action, repeated: true},
  ],
  {localName: "ListActionsAndIssuesGraphResponse_ActionLane"},
);

/**
 * @generated from message wavin.aqora.v2.UpdateUserGlobalPermissionsRequest
 */
export const UpdateUserGlobalPermissionsRequest = proto3.makeMessageType(
  "wavin.aqora.v2.UpdateUserGlobalPermissionsRequest",
  () => [
    {no: 1, name: "user_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "global_permissions", kind: "enum", T: proto3.getEnumType(GlobalPermission), repeated: true},
  ],
);

